import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 * This component accepts up to 7 CMS components
 * Only use: Collection banners
 */
class Layout_multiple_horizontal extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <Row>
          <div className="hidden-borders">
            <Col xs={6} sm={4} md={3}>{this.componentDOM(0)}</Col>
            <Col xs={6} sm={4} md={3}>{this.componentDOM(1)}</Col>
            <Col xs={6} sm={4} md={3}>{this.componentDOM(2)}</Col>
            <Col xs={6} sm={4} md={3}>{this.componentDOM(3)}</Col>
            <Col sm={4} md={3} className="hidden-xs">{this.componentDOM(4)}</Col>
            <Col sm={4} md={3} className="hidden-xs">{this.componentDOM(5)}</Col>
            <Col md={3} className="hidden-xs hidden-sm">{this.componentDOM(6)}</Col>
            <Col md={3} className="hidden-xs hidden-sm">{this.componentDOM(7)}</Col>
          </div>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_multiple_horizontal;
